var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent","height":"420"}},[_c('GChart',{attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions,"width":"420"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }